<template>
  <v-snackbar multi-line
    bottom
    :timeout="timeout"
    :color="color"
    shaped
    v-model="show">
    <v-icon class="mr-2">mdi-{{ getIcon() }}</v-icon>
    <span v-html="text"></span>
    <v-btn dark text icon @click="show = false" >
      <v-icon>mdi-close</v-icon>
    </v-btn>
  </v-snackbar>
</template>

<script>
import events from 'Store/events'
export default {
  name: 'notify-main',
  data () {
    return {
      show: false,
      text: '',
      color: 'info',
      timeout: 2000
    }
  },
  mounted () {
    events.subNotify((data) => {
      // do not translate if raw flag is set
      this.text = data.raw ? data.text : this.$t(data.text, data.args)
      this.color = data.status || 'info'
      this.show = true
      this.timeout = data.timeout || 2000
    })
    events.subError((message) => {
      if (typeof message === 'string') {
        this.text = message
      } else {
        this.text = this.$t(message.key, message.args)
      }
      this.color = 'error'
      this.show = true
      this.timeout = 6000
    })
  },

  methods: {
    getIcon () {
      if (this.color === 'success') {
        return 'checkbox-marked-circle'
      } else if (this.color === 'error') {
        return 'alert'
      } else {
        return 'information'
      }
    }
  }
}
</script>

<style scoped>
</style>
